import { InlinePRData } from '@nykaa/sitewide-prices-revealed/inlinePriceReveal/types';
import { isValidObject } from '@nykaa/utils/validations';
import {
  RawCohortSaleTemplate,
  RawPriceRevealInfo,
  RawSaleTemplateCardInfo,
} from 'types/PriceReveal';

export const getUpdatedTemplateV2 = (
  saleTemplate: RawCohortSaleTemplate,
  saleTemplateV2: RawCohortSaleTemplate
) => {
  if (!isValidObject(saleTemplate)) {
    return saleTemplateV2;
  }
  if (!isValidObject(saleTemplateV2)) {
    return null;
  }
  Object.keys(saleTemplate).forEach((key) => {
    if (saleTemplateV2[key] === null || saleTemplateV2[key] === undefined) {
      saleTemplateV2[key] = saleTemplate[key];
    }
  });
  return saleTemplateV2;
};

export const transformPriceRevealData = (
  prData: RawPriceRevealInfo,
  templateData: RawSaleTemplateCardInfo
): InlinePRData | null => {
  if (!isValidObject(prData) && !isValidObject(templateData)) {
    return null;
  }
  return {
    price: templateData ? templateData.price : prData.sp,
    discount: templateData ? templateData.discount : prData.discount,
    templateType: templateData?.template_type,
    text: templateData?.text,
    textColor: templateData?.text_color,
    priceColor: templateData?.price_color,
    discountColor: templateData?.discount_color,
    borderRadius: templateData?.border_radius,
    bgColor: templateData?.bg_color,
    imageUrl: templateData?.right_image_url || '',
    imageAspectRatio: templateData?.right_image_aspect_ratio?.web || '',
  };
};

// TODO review- move from here?
export const getCohortSaleData = (templateData: RawCohortSaleTemplate) => {
  if (!isValidObject(templateData)) {
    return null;
  }

  return {
    price: templateData?.price || '',
    discount: templateData?.sub_heading || '',
    templateType: templateData?.template_type,
    text: templateData?.text,
    textColor: templateData?.text_color,
    priceColor: templateData?.price_color,
    discountColor: templateData?.discount_color,
    showPinkBoxCTA: templateData?.show_pink_box_button,
    templateId: templateData?.template_id,
    borderRadius: templateData?.border_radius,
    bgColor: templateData?.bg_image,
    imageUrl: templateData?.right_image_url || '',
    imageAspectRatio: templateData?.right_image_aspect_ratio?.web || '',
  };
};

export const getCohortSaleDataV2 = (
  templateData: RawCohortSaleTemplate,
  assetsBucket?: any
) => {
  if (!isValidObject(templateData)) {
    return null;
  }

  const crownImage = isValidObject(assetsBucket)
    ? assetsBucket[templateData?.crownImage]
    : '';
  return {
    price: templateData?.price || '',
    discount: templateData?.sub_heading || '',
    templateType: templateData?.template_type,
    text: templateData?.text,
    textV2: templateData?.text_v2 || '',
    textColor: templateData?.text_color,
    textTransparency: templateData?.text_transparency || 1,
    priceColor: templateData?.price_color,
    priceTransparency: templateData?.price_transparency || 1,
    discountPercentage: templateData?.discountPercentage || 0,
    discountColor: templateData?.discount_color,
    showPinkBoxCTA: templateData?.show_pink_box_button,
    templateId: templateData?.template_id,
    borderRadius: templateData?.border_radius,
    bgColor: templateData?.bg_image,
    imageUrl: templateData?.right_image_url || '',
    imageAspectRatio: templateData?.right_image_aspect_ratio?.web || '',
    crownImage,
    gradientColors: templateData?.gradient_color,
    animationSpeed: templateData?.animation_speed,
    rotationSpeed: templateData?.rotation_speed,
    animationLoop: templateData?.animation_loop,
    primaryImg: templateData?.primary_image || '',
    secondaryImg: templateData?.secondary_image || '',
    startTime: templateData?.start_time,
    endTime: templateData?.end_time,
    timerColor: templateData?.timer_color,
    showTimer: templateData?.show_timer,
    icon: templateData?.icon,
    primaryImageWidth: templateData?.primary_image_width,
    subHeading: templateData?.sub_heading || '',
    subHeadingColor: templateData?.sub_heading_color || '',
    subHeadingTransparency: templateData?.sub_heading_transparency,
  };
};
